import { render, staticRenderFns } from "./SaleDialog.vue?vue&type=template&id=546eb5c6"
import script from "./SaleDialog.vue?vue&type=script&lang=js"
export * from "./SaleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports